module.exports = __webpack_public_path__ + "bestseller.svg?3519c914b38a4fb731fe02d5b99a532f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bestseller.svg
// module id = 279
// module chunks = 2